import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const ColumnChart = () => {
  const options = {
    chart: {
      type: "bar",
    },
    title: {
      text: "Network Comparison: % of Medicare",
      align: "center",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
    },
    xAxis: {
      categories: [
        "Inpatient (IPPS)",
        "Outpatient (OPPS)",
        "Professional (PFS)",
        "Medicare Part B Drugs (DrugB)",
      ],
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "12px",
          width: "100px",
        },
      },
    },
    yAxis: {
      title: {
        text: "% of Medicare",
        style: {
          fontSize: "14px",
          fontWeight: "light",
          fontFamily: "'Roboto Flex', serif",
        },
      },
      plotLines: [
        {
          value: 70,
          dashStyle: "dash",
          width: 1,
          color: "#B4B4B4",
          zIndex: 5,
          label: {
            text: "threshold",
            align: "right",
            verticalAlign: "top",
            rotation: 0,
            x: 10,
            y: -5,
            style: {
              color: "#666",
              fontSize: "10px",
              fontWeight: "light",
            },
          },
        },
      ],
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderRadius: 3,
        pointPadding: 0.2,
        groupPadding: 0.1,
        dataLabels: {
          enabled: true,
          format: "{y}%",
          style: {
            fontSize: "0px",
            fontWeight: "bold",
            color: "black",
          },
          inside: false,
        },
        cursor: "pointer",
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      pointFormat:
        "<span style='margin-right:100px; width:45px'> {series.name}</span> <span style='display: inline-block;position:absolute;padding-left:-2px;width: 50px; text-align:right;right:0'><b>{point.y}%</span></b><br/>",

      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false,
      hideDelay: 0,
      width: 100,
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        transition: "none",
        fontSize: "12px",
        padding: "8px",
        shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
        zIndex: 99999,
      },
      shadow: true,
      useHTML: true,
      outside: true,
    },
    series: [
      {
        name: "Anthem High Performance Network",
        data: [244.22, 265.96, 145.86, 133.83],
        color: "#c4dbd9",
      },
      {
        name: "Anthem Traditional Network",
        data: [238.45, 260.44, 150.38, 134.62],
        color: "#f7bf9e",
      },
      {
        name: "BC ID Blue Value POS Network",
        data: [255.04, 264.34, 145.9, 135.06],
        color: "#f7e6da",
      },
      {
        name: "BC ID Preferred Blue Network	",
        data: [255.04, 264.34, 145.9, 135.06],
        color: "#f4e7bb",
      },
    ],
  };

  const options1 = {
    chart: {
      type: "bar",
    },
    title: {
      text: "Categories Comparison: % of Medicare",
      align: "center",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
    },
    xAxis: {
      categories: [
        "Anthem High Performance Network",
        "Anthem Traditional Network",
        "BC ID Blue Value POS Network",
        "BC ID Preferred Blue Network",
      ],
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "12px",
          width: "100px",
        },
      },
    },
    yAxis: {
      title: {
        text: "% Discount",
        style: {
          fontSize: "14px",
          fontWeight: "bold",
          fontFamily: "'Roboto Flex', serif",
        },
      },
      labels: {
        formatter: function () {
          return this.value + "%";
        },
      },
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderRadius: 3,
        pointPadding: 0.2,
        groupPadding: 0.1,
        dataLabels: {
          enabled: true,
          format: "{y}%",
          style: {
            fontSize: "0px",
            fontWeight: "bold",
            color: "black",
          },
          inside: false,
        },
        cursor: "pointer",
      },
    },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      pointFormat:
        "<span style='margin-right:100px; width:45px'> {series.name}</span> <span style='display: inline-block;position:absolute;padding-left:-2px;width: 50px; text-align:right;right:0'><b>{point.y}%</span></b><br/>",

      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false,
      hideDelay: 0,
      width: 100,
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        transition: "none",
        fontSize: "12px",
        padding: "8px",
        shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
        zIndex: 99999,
      },
      shadow: true,
      useHTML: true,
      outside: true,
    },
    series: [
      {
        name: "Inpatient (IPPS)",
        data: [244.22, 238.45, 255.04, 255.04], // Data changed for testing
        color: "#c4dbd9",
      },
      {
        name: "Outpatient (OPPS)",
        data: [265.96, 260.44, 264.34, 264.34],
        color: "#f7bf9e",
      },
      {
        name: "Professional (PFS)",
        data: [145.86, 150.38, 145.9, 145.9],
        color: "#f7e6da",
      },
      {
        name: "Medicare Part B Drugs (DrugB)",
        data: [133.83, 134.62, 135.06, 135.06],
        color: "#f4e7bb",
      },
    ],
  };

  return (
    <div className="d-flex flex-row gap-3" style={{ padding: "0px 20px" }}>
      heelo
      <HighchartsReact highcharts={Highcharts} options={options} />
      <HighchartsReact highcharts={Highcharts} options={options1} />
    </div>
  );
};

export default ColumnChart;
